module.exports = __webpack_public_path__ + "static/media/Icon02.1b745143.png";